import { createGlobalStyle } from "styled-components";
import { Theme } from "./Theme";

export const GlobalStyles = createGlobalStyle`
*, 
*::before,
*::after {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: rgba(106, 217, 255, 0.52) rgba(255, 255, 255, 0.04);
}

html,
body,
#root {
  width: 100%;
  height: 100%;
  min-height: 100%;
}

html {
  scroll-behavior: smooth;
}

*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.04);
  border-radius: 999px;
}

*::-webkit-scrollbar-thumb {
  border-radius: 999px;
  border: 2px solid transparent;
  background-clip: padding-box;
  background:
    linear-gradient(
      180deg,
      rgba(149, 239, 255, 0.72) 0%,
      rgba(106, 217, 255, 0.54) 100%
    );
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.18),
    0 0 10px rgba(106, 217, 255, 0.12);
}

*::-webkit-scrollbar-thumb:hover {
  background:
    linear-gradient(
      180deg,
      rgba(176, 245, 255, 0.82) 0%,
      rgba(106, 217, 255, 0.68) 100%
    );
}

*::-webkit-scrollbar-thumb:active {
  background:
    linear-gradient(
      180deg,
      rgba(176, 245, 255, 0.9) 0%,
      rgba(106, 217, 255, 0.8) 100%
    );
}

*::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}

*::-webkit-scrollbar-corner {
  background: transparent;
}

body {
  position: relative;
  background-color: ${Theme.colors.blockColor};
  color: ${Theme.colors.mainFontColor};
  font-family: "Manrope", sans-serif;
  overflow: hidden;
  overscroll-behavior-y: none;
}

body.landing-scroll {
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: auto;
}
`;
